import React from "react";

import styles from "../chatPage.scss";

export const Separator = (props) => {
    return <div className={styles.separator} {...props} />;
};



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/ChatsList/Separator.tsx